// Biomond desktop search: one request per input; Shopify renders image, title and price.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header__search-form').forEach((form) => {
    const input = form.querySelector('.header__search-input');
    const container = form.querySelector('[data-search-suggestions]');
    if (!input || !container) return;
    let controller;
    let timer;
    function clear() { container.hidden = true; container.replaceChildren(); }
    input.addEventListener('input', () => {
      clearTimeout(timer);
      if (controller) controller.abort();
      const query = input.value.trim();
      if (query.length < 2) { clear(); return; }
      timer = setTimeout(async () => {
        const requestController = new AbortController();
        controller = requestController;
        const root = window.Shopify?.routes?.root || '/';
        const params = new URLSearchParams({q: query, 'resources[type]': 'product',
          'resources[limit]': '4', 'options[prefix]': 'last', section_id: 'predictive-search'});
        try {
          const response = await fetch(`${root}search/suggest?${params}`, {signal: requestController.signal});
          if (!response.ok) throw new Error('Search request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (requestController.signal.aborted || input.value.trim() !== query) return;
          const source = html.querySelector('.f-predictive-search__block-products ul');
          if (!source || !source.children.length) { clear(); return; }
          const list = source.cloneNode(true);
          list.removeAttribute('id');
          list.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          list.querySelectorAll('li').forEach(el => el.classList.add('header__search-suggestion'));
          list.querySelectorAll('a').forEach(el => {
            el.classList.add('header__search-suggestion-link'); el.removeAttribute('tabindex');
          });
          list.querySelectorAll('.f-predictive-search__item-image').forEach(el => el.classList.add('header__search-suggestion-image'));
          list.querySelectorAll('.f-predictive-search__item-content').forEach(el => el.classList.add('header__search-suggestion-text'));
          container.replaceChildren(list); container.hidden = false;
        } catch (error) {
          if (error.name !== 'AbortError') clear();
        }
      }, 180);
    });
    document.addEventListener('click', event => { if (!form.contains(event.target)) clear(); });
    input.addEventListener('keydown', event => { if (event.key === 'Escape') clear(); });
  });
});
